import { render } from "./CollectInfoConfirm.vue?vue&type=template&id=4b419680&scoped=true&ts=true"
import script from "./CollectInfoConfirm.vue?vue&type=script&lang=ts"
export * from "./CollectInfoConfirm.vue?vue&type=script&lang=ts"

import "./CollectInfoConfirm.vue?vue&type=style&index=0&id=4b419680&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b419680"]])

export default __exports__